<template>
  <section class="content" style="background-color: #EBECF1">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-info">
          <div class="box-header">
            <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE APLICACIONES</h3>
          </div>
          <div class="box-body">
            <form role="form">
              <div class="box-header" style="padding-left:15px;">
                <button type="button" class="fuente btn btn-primary fs-13" @click="limpiar()" data-toggle="modal"
                  data-target="#modalNuevo">Nuevo Registro</button>
              </div>
              <div class="row">
                <div class="fuente col-xs-12 table-responsive">
                  <div class="box-body">
                    <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                      class="fuente fs-12 table table-bordered table-striped dataTable">
                      <thead>
                        <tr role="row">
                          <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">ITEM</th>
                          <th aria-label="DESCRIPCIÓN" aria-sort="ascending" aria-controls="tablaDetalle" tabindex="0"
                            class="sorting_asc">DESCRIPCIÓN</th>
                          <th aria-label="URL" aria-controls="tablaDetalle" tabindex="0" class="sorting">URL</th>
                          <th aria-label="ICONO" aria-controls="tablaDetalle" tabindex="0" class="sorting">ICONO</th>
                          <th aria-label="SIGLA" aria-controls="tablaDetalle" tabindex="0" class="sorting">SIGLA</th>
                          <th aria-label="MODIFICAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">MODIFICAR
                          </th>
                          <th aria-label="DETALLE" aria-controls="tablaDetalle" tabindex="0" class="sorting">DETALLE</th>
                          <th aria-label="ANULAR" aria-controls="tablaDetalle" tabindex="0" class="sorting">ANULAR</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="odd" role="row" v-for="item in apps">
                          <td class="sorting_1">{{ item.cont }}</td>
                          <td>{{ item.descripcion }}</td>
                          <td>{{ item.url }}</td>
                          <td>{{ item.icono }}</td>
                          <td>{{ item.sigla }}</td>
                          <td><span style="cursor:pointer" class="badge bg-blue" data-toggle="modal" @click="ver(item)"
                              data-target="#modalNuevo">O</span></td>
                          <td>
                            <router-link
                              :to="{ name: 'aplicaciones_detalle' /*, params: { idApp: item.idApp, descripcionApp: item.descripcion }*/ }">
                              <span @click="enviarApp(item)" style="cursor:pointer"
                                class="badge bg-yellow">
                                V
                              </span>
                            </router-link>
                          </td>
                          <td><span style="cursor:pointer" class="badge bg-red" data-toggle="modal"
                              @click="verAnular(item)" data-target="#modalAnular">X</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="fuente col-md-12" style="color: red;">
                    {{ error.desError }}
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalNuevo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                      </div>
                      <div class="fuente modal-body fs-12">
                        NOMBRE DE LA APLICACIÓN *<br />
                        <input type="text" class="form-control m-t-10" :value="app.descripcion"
                          @input="handleDescripcionInput" required="true" /><br />
                        DIRECCIÓN WEB<br />
                        <input type="text" class="form-control m-t-10" v-model="app.url" /><br />
                        ICONO<br />
                        <input type="text" class="form-control m-t-10" v-model="app.icono" /><br />
                        SIGLA *<br />
                        <div class="row">
                          <div class="col-md-5">
                            <input type="text" class="form-control m-t-10" :value="app.sigla" @input="handleSiglaInput"
                              required="true" :disabled="!SiglaEditMode || app.descripcion == ''" />
                          </div>
                          <div class="col-md-4" v-if="app.sigla !== '' && showButton"><br>
                            <button type="button" class="fuente fs-20" @click="EnabledEditSigla" title="Editar Sigla"
                              data-toggle="tooltip">
                              <i class="fa fa-pencil-square-o" aria-label="Editar Sigla"></i>
                            </button>
                          </div>
                        </div>
                        <small class="text-danger">{{ mensajeLimiteSigla }}</small>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-primary fs-13" @click="merge()" data-dismiss="modal"
                          :disabled="!app.descripcion || !app.sigla" data-toggle="tooltip" data-placement="top"
                          :title="(!app.descripcion || !app.sigla) ? 'Para guardar, complete los campos requeridos (*)' : ''">
                          Guardar Cambios</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <form>
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">X</span></button>
                        <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEAS ANULAR LA APLICACIÓN?</h4>
                      </div>
                      <div class="fuente modal-body">
                        Se anulará la aplicación {{ app.descripcion }} <br />
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="fuente btn btn-danger fs-13" @click="merge()"
                          data-dismiss="modal">Anular Aplicación</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//import Aplication_DetalleView from './Aplication_Detalle.vue'
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state' //llamando al apiURL del store
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
  name: 'Tables',
  data() {
    return {
      apps: [],
      trabajadores: [],
      rolByUsu: [],
      rols: [],
      opeByRol: [],
      operaciones: [],
      texto: '',
      error: {
        desError: ''
      },
      error2: {
        desError: ''
      },
      error3: {
        desError: ''
      },
      error4: {
        desError: ''
      },
      error5: {
        desError: ''
      },
      app: {
        idApp: '0',
        descripcion: '',
        url: '',
        icono: '',
        sigla: '',
        flagActivo: '1',
        usuario: this.$session.get('user')
      },
      mensajeLimiteSigla: '', //Limitar caracteres en la caja de texto Sigla del modal      
      SiglaEditMode: false,
      showButton: true,
      tiempoActual: null,
      tiempoTokenExp: null
    }
  },
  mounted() {    
    //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
    this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");     
    //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
    this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
    
    if (!this.$session.exists('token')) {
      App.methods.logout.call(this);
      return;
    }

    if (this.tiempoActual < this.tiempoTokenExp) {

      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      // Realizar la validación con la API
      axios.get(`${apiLOGIN}/operaciones/app/GESU/aplicaciones`)
        .then(response => {
          //console.log("API validador de permisos:", response)
          if (response.data.codError === 1 || response.data.desError === 'ok') {
            // La validación es exitosa, continuar con la carga de datos            
            this.carga();
          } else {            
            //this.$router.go(-1);
            this.alertaError();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            // Manejar el caso de error de autorización
            this.alertaError401();
            //this.$router.go(-1);
          } else if (error.response && error.response.status === 403) {
            //this.$router.go(-1);
            this.alertaError();
          } else if (error.response && error.response.status === 500) {
            //this.$router.go(-1); 
            this.alertaError500();
          } else {
            //this.$router.go(-1);
            this.alertaError401();
          }
        });
    } else {
      this.alertaError401();
    }
  },

  methods: {
    //Cargar datos a la DataTable
    carga() {
      // Destruir la instancia DataTable si ya existe
      const dataTableInstance = $('#tablaDetalle').DataTable();
      if (dataTableInstance) {
        dataTableInstance.destroy();
      }
      axios.defaults.headers.common['Authorization'] = this.$session.get('token')
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/aplicaciones/*'
        `${apiURL}/aplicaciones/*`
      ).then(response => {
        this.apps = response.data

        this.$nextTick(() => {
          $('#tablaDetalle').DataTable({
            stateSave: true, // Habilitar el stateSave, para guardar el estado y la paginación de la tabla
            'stateSaveParams': function (settings, data) {
              data.length = 25; // Establece la longitud de la página
            },
            pageLength: 25,
            'oLanguage': {
              'sSearch': 'Buscar',
              'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
              'sEmptyTable': 'Sin Data',
              'sZeroRecords': 'No se encontraron coincidencias',
              'sInfoFiltered': '(Filtrado de un total de _MAX_ registros)',
              'sLengthMenu': '_MENU_ Registros por página',
              'sInfoEmpty': 'Mostrando 0 al 0 de 0 registros',
              'oPaginate': {
                'sPrevious': 'Anterior',
                'sNext': 'Siguiente'
              }
            }
          })
        })
      })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            App.methods.logout.call(this);
          } else {
            // console.error(error);
          }
        })
    },
    merge: function () {
      if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
        axios.post(
          //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/app/add',
          `${apiURL}/operaciones/app/add`,
          {
            'idApp': this.app.idApp,
            'descripcion': this.app.descripcion,
            'url': this.app.url,
            'icono': this.app.icono,
            'sigla': this.app.sigla,
            'flagActivo': this.app.flagActivo,
            'usuario': this.$session.get('user')
          }
        ).then(response => {
          this.error = response.data

          ////////--------------- AL ANULAR -------------------
          //// Si se anuló la aplicación anular también: aplicacionxusuario, rol, rolxusuario, operacion y operacionxrol        
          if (this.app.flagActivo == '0') {
            //console.log('--this.app.flagActivo', this.app.flagActivo)

            /////// 1: Buscar todos los Usuarios x Aplicación (tabla aplicacionxusuario), obtener los idUsuario y los idAppXUsu          
            axios.get(`${apiURL}/usuarios/trabajadores/` + this.app.idApp)
              .then(response => {
                this.trabajadores = response.data;
                //console.log('Trabajadores obtenidos:', this.trabajadores);

                ///// 2: if (si length !== '0'), forEach y a cada idAppXUsu anularlo
                if (this.trabajadores.length !== 0) {
                  //console.log('hay usuarios registrados en esta App')
                  this.trabajadores.forEach((array) => {
                    axios.post(
                      `${apiURL}/operaciones/appByUsu/add`,
                      {
                        'idAppXUsu': array.idAppXUsu,
                        'idUsuario': array.idUsuario,
                        'flagActivo': '0',
                        'usuario': this.$session.get('user')
                      }
                    ).then(response => {
                      this.error2 = response.data

                      ///// 3: Con el idUsuario e idApp, buscar todos los roles x usuario (tabla rolxusuario) y obtener los idRolXUsu (sus idRol están vacíos '0')
                      axios.get(
                        `${apiURL}/operaciones/rolByUsu/` + array.idUsuario + '/' + this.app.idApp
                      ).then(response => {
                        this.rolByUsu = response.data
                        //console.log('roles según el idUsuario en esta App:', this.rolByUsu);

                        /// 4: if (si length !== '0'), forEach y a cada idRolXUsu anularlo
                        if (this.rolByUsu.length !== 0) {
                          this.rolByUsu.forEach((array2) => {
                            ///Se anulará cada rol del Usuario de esta aplicación 
                            axios.post(
                              `${apiURL}/operaciones/rolByUsu/add`,
                              {
                                'idUsuario': array2.idUsuario, ///no hay idUsuario '0', pero no es necesario para anular
                                'idRol': array2.idRol, ////no hay idRol '0', pero no es necesario para anular
                                'idRolXUsu': array2.idRolXUsu, //// Solo se necesita este dato para anular en el procedimiento almac.
                                'flagActivo': '0',
                                'usuario': this.$session.get('user')
                              }
                            ).then(response => {
                              this.error2 = response.data
                            })
                              .catch(error => {
                                if (error.response.status === 401) {
                                  App.methods.logout.call(this);
                                }
                              })
                          })
                        }
                      })
                        .catch(error => {
                          if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })
                    })
                      .catch(error => {
                        if (error.response && error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  })
                }
              })
              .catch(error => {
                console.error('Error al obtener trabajadores de la Aplicación:', error);
                if (error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              });

            //// 5: Buscar los idRol x Aplicación, (si length > '0') hacer un forEach y anular cada idRol
            axios.get(`${apiURL}/operaciones/rolByApp/` + this.app.idApp)
              .then(response => {
                this.rols = response.data;
                //console.log('--Roles obtenidos:', this.rols);

                if (this.rols.length > 0) {
                  this.rols.forEach((array3) => {
                    axios.post(
                      `${apiURL}/operaciones/rol/add`,
                      {
                        'idRol': array3.idRol,
                        'descripcion': array3.descripcion,
                        'idApp': array3.idApp,
                        'flagActivo': '0',
                        'usuario': this.$session.get('user')
                      }
                    ).then(response => {
                      this.error3 = response.data

                      //// 6: Dentro del forEach, buscar todas las operacionxrol según el idRol y obtener los idOpeXRol
                      axios.get(
                        `${apiURL}/operaciones/opexrolByRol/` + array3.idRol
                      ).then(response => {
                        this.opeByRol = response.data

                        //// 7: if (si length > '0'), forEach y anular cada idOpeXRol
                        if (this.opeByRol.length > 0) {
                          this.opeByRol.forEach((array4) => {
                            axios.post(
                              `${apiURL}/operaciones/opeByRol/add`,
                              {
                                'idOpeXRol': array4.idOpeXRol,
                                'idRol': array4.idRol,
                                'idOperacion': array4.idOperacion,
                                'flagActivo': '0',
                                'usuario': this.$session.get('user')
                              }
                            ).then(response => {
                              this.error4 = response.data

                            })
                              .catch(error => {
                                if (error.response.status === 401) {
                                  App.methods.logout.call(this);
                                }
                              })
                          })
                        }
                      })
                        .catch(error => {
                          if (error.response.status === 401) {
                            App.methods.logout.call(this);
                          }
                        })
                    })
                      .catch(error => {
                        if (error.response.status === 401) {
                          App.methods.logout.call(this);
                        }
                      })
                  })
                }

              })
              .catch(error => {
                console.error('Error al obtener roles de la Aplicación:', error);
                if (error.response && error.response.status === 401) {
                  App.methods.logout.call(this);
                } else if (error.response && error.response.status === 404) {
                  App.methods.logout.call(this);
                }
              });

            //// 8: Buscar todas las Operaciones x Aplicación
            axios.get(
              `${apiURL}/operaciones/*/` + this.app.idApp + '/0'
            ).then(response => {
              this.operaciones = response.data;
              //console.log('-- Operaciones x idApp:', this.operaciones);

              //// 9: if (si length > '0'), forEach y anular cada  idOperacion
              if (this.operaciones.length > 0) {
                this.operaciones.forEach((array5) => {
                  axios.post(
                    `${apiURL}/operaciones/ope/add`,
                    {
                      'idOperacion': array5.idOperacion,
                      'descripcion': array5.descripcion,
                      'idApp': array5.idApp,
                      'flagPrincipal': array5.flagPrincipal,
                      'enlaceWeb': array5.enlaceWeb,
                      'idOpeSup': array5.idOpeSup,
                      'flagSeccion': array5.flagSeccion,
                      'icono': array5.icono,
                      'titulo_adic': array5.titulo_adic,
                      'icono_adic': array5.icono_adic,
                      'descripcion_adic': array5.descripcion_adic,
                      'flagActivo': '0',
                      'usuario': this.$session.get('user')
                    }
                  ).then(response => {
                    this.error5 = response.data

                  })
                    .catch(error => {
                      if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                      }
                    })
                })
              }
            })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  App.methods.logout.call(this);
                }
              })
          }          
          ///Recargar tabla al finalizar
          this.carga();
        })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              App.methods.logout.call(this);
            }
          })
      } else {
        this.alertaError401();
      }
    },
    ver: function (app) {
      this.texto = 'ACTUALIZAR LOS DATOS DE LA APLICACIÓN';
      this.app = { ...app };
      this.mensajeLimiteSigla = ''
      this.error.desError = ''
      this.SiglaEditMode = true
      this.showButton = false
    },

    verAnular: function (app) {
      this.app = { ...app }
      this.app.flagActivo = '0'
      this.error.desError = ''
    },
    limpiar: function () {      
      axios.get(
        //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/aplicaciones/*'
        `${apiURL}/aplicaciones/*`
      ).then(response => {
        this.apps = response.data
      })
        .catch(error => {
          if (error.response.status === 401) {
            App.methods.logout.call(this);
          }
        })
      this.texto = 'REGISTRAR UNA NUEVA APLICACIÓN'
      this.app.idApp = '0'
      this.app.descripcion = ''
      this.app.url = ''
      this.app.icono = ''
      this.app.sigla = ''
      this.app.flagActivo = '1'
      this.mensajeLimiteSigla = ''
      this.error.desError = ''
      this.SiglaEditMode = false
      this.showButton = true
    },
    //// Limitar cant. máxima de caracteres en la caja de texto Sigla del modal Nuevo
    verificarLimiteSigla() {
      const MAX_CARACTERES = 6; // Definir el límite máximo de caracteres      
      // Obtener la sigla sin espacios en blanco al inicio y al final
      const siglaSinEspacios = this.app.sigla.trim();
      // Verificar si la longitud excede el límite
      if (siglaSinEspacios.length > MAX_CARACTERES) {
        // Truncar la sigla a la longitud máxima permitida
        this.app.sigla = siglaSinEspacios.slice(0, MAX_CARACTERES);
        // Mostrar el mensaje de límite
        this.mensajeLimiteSigla = `⚠️ Máximo de ${MAX_CARACTERES} caracteres permitidos`;
      } else {
        this.mensajeLimiteSigla = '';
      }
    },
    //Para convertir en mayúscula el texto ingresado en cajas (Descripción y Sigla)
    formatToUpperCase(property, event) {
      this.app[property] = event.target.value.toUpperCase();
    },
    ///Eliminar espacios en blanco y algunos caracteres especiales
    removeSpacesAndSpecialChars(property) {
      this.app[property] = this.app[property].replace(/[^A-Za-z0-9_\-\.]/g, '');
    },
    //Combinar 2 eventos en la caja de texto Sigla
    handleSiglaInput(event) {
      // Convertir a mayúsculas y verificar límite de caracteres
      this.formatToUpperCase('sigla', event);
      // Eliminar espacios en blanco y caracteres no deseados en el campo Sigla
      this.removeSpacesAndSpecialChars('sigla');
      this.verificarLimiteSigla();
    },
    // Se crea la sigla automáticamente con las 1ras letras de cada palabra del campo Descripción
    crearSigla() {
      // Obtener las primeras letras de cada palabra del campo Descripción
      const palabras = this.app.descripcion.split(' ');
      this.app.sigla = palabras.map(palabra => palabra.charAt(0).toUpperCase()).join('');

      const MAX_CARACTERES = 6; // Definir el límite máximo de caracteres
      // Verificar si la longitud excede el límite
      if (this.app.sigla.length > MAX_CARACTERES) {
        // Truncar la sigla a la longitud máxima permitida
        this.app.sigla = this.app.sigla.slice(0, MAX_CARACTERES) + '';
        // Mostrar el mensaje de límite
        this.mensajeLimiteSigla = `⚠️ Máximo de ${MAX_CARACTERES} caracteres para Sigla`;
      } else {
        this.mensajeLimiteSigla = '';
      }
    },
    handleDescripcionInput(event) {
      // Llamando al Método para convertir a mayúsculas
      this.formatToUpperCase('descripcion', event);
      // Llamando al Método para crear la Sigla, solo cuando se está creando un nuevo registro      
      this.crearSigla();
    },
    //// Habilitar edición del campo Sigla
    EnabledEditSigla() {
      this.SiglaEditMode = true;
      this.showButton = false;
    },
    alertaError() {
      Swal.fire({
        icon: 'error',
        title: 'Usuario No Autorizado',
        text: 'No tienes permisos para acceder.',
        timer: 2000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {        
        //App.methods.logout.call(this);
        this.$router.go(-1);
      });
    },
    alertaError401() {
      Swal.fire({
        icon: 'error',
        title: 'La sesión ha expirado',
        //text: 'Vuelve a iniciar sesión.',
        footer: '<a href="#">Vuelve a iniciar sesión.</a>',
        timer: 3000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.        
        //this.$session.destroy()
        //this.$router.push('/login')
        App.methods.logout.call(this); ///Cierra la sesión         
      });
    },
    alertaError500() {
      Swal.fire({
        icon: 'error',
        title: 'Error interno del servidor',
        text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
        timer: 5000, // Duración en milisegundos
        timerProgressBar: true,
        showConfirmButton: false
      }).then(() => {
        // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
        //this.$session.destroy()
        //this.$router.push('/login')
        this.$router.go(-1);
      });
    },
    enviarApp(item) {            
      localStorage.setItem('idApp', item.idApp)
      localStorage.setItem('desApp', item.descripcion)      
      //console.log('---item', localStorage.getItem('idApp'), localStorage.getItem('desApp'))
      this.$router.push('/aplicaciones_detalle');      
    },
  }
}

</script>

<style>
@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
</style>



// WEBPACK FOOTER //
// Aplication.vue?238b5e78